import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type PickerButtonProps = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  'data-testid'?: string;
};

export const PickerButton = ({
  onClick,
  children,
  className,
  disabled,
  'data-testid': dataTestId,
}: PropsWithChildren<PickerButtonProps>) => {
  return (
    <button
      type='button'
      className={classNames(
        'relative px-3 py-1.5 block leading-relaxed rounded-md bg-white text-xs 2xl:text-sm tracking-wide font-semibold transition-colors border border-transparent uppercase focus:bg-primary-lighter-10 focus:ring focus:ring-primary focus:ring-opacity-10 focus:outline-none',
        {
          'hover:bg-white-snow': !disabled,
          'cursor-not-allowed opacity-50': disabled,
        },
        className,
      )}
      data-testid={dataTestId}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
